import {
  ArrowLeftOutlined,
  ArrowRightOutlined,
  PlaySquareOutlined,
} from '@ant-design/icons'
import { Button } from 'antd'
import { t } from 'i18next'
import { memo, useMemo } from 'react'
import styled from 'styled-components'
import { useWorkspaceDetails } from '../../../../../../hooks'
import useWorkspaceSmartFunctionData from '../../../../../../hooks/useWorkspaceSmartFunctionData'

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-top: 24px;
  gap: 8px;
`

interface RegulatorySubmissionConfigurationModalFooterProps {
  onCancel: () => void
  onNext?: () => void
  nextDisabled?: boolean
  onPrevious?: () => void
  onSubmit?: () => void
}

const RegulatorySubmissionConfigurationModalFooter = memo(
  ({
    onCancel,
    onNext,
    nextDisabled = false,
    onPrevious,
    onSubmit,
  }: RegulatorySubmissionConfigurationModalFooterProps) => {
    const { selectedWorkspace } = useWorkspaceDetails({
      preventFetch: true,
    })

    const { isStatusOngoing } = useWorkspaceSmartFunctionData()

    const isDisabled = useMemo(() => {
      return isStatusOngoing(selectedWorkspace?.algorithmRuns ?? [])
    }, [isStatusOngoing, selectedWorkspace])

    return (
      <Footer>
        <Button onClick={onCancel} type="text">
          {t('Cancel')}
        </Button>
        {onPrevious && (
          <Button
            type="default"
            icon={<ArrowLeftOutlined />}
            onClick={onPrevious}
          >
            {t('Previous')}
          </Button>
        )}
        {onNext && (
          <Button
            icon={<ArrowRightOutlined />}
            disabled={nextDisabled}
            type="primary"
            onClick={onNext}
          >
            {t('Next')}
          </Button>
        )}
        {onSubmit && (
          <Button
            icon={<PlaySquareOutlined />}
            type="primary"
            onClick={onSubmit}
            disabled={isDisabled}
          >
            {t('regulatorySubmissionConfigurationModal.runAlgorithm')}
          </Button>
        )}
      </Footer>
    )
  }
)

export default RegulatorySubmissionConfigurationModalFooter
